import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import http from '../../services/httpService';

const ProtectedRoute = ({ path, component: Component, render, ...rest }) => {
	return (
		<Route
			{...rest}
			render={(props) => {
				if (!http.getCurrentUser())
					return (
						<Redirect
							to={{
								pathname: '/login',
								state: { from: props.location },
							}}
						/>
					);
				return Component ? <Component {...props} /> : render(props);
			}}
		/>
	);
};

export default ProtectedRoute;
